import request from "@/utils/request";
export default {
	// 用户注册
	register(username, password, group_id, inviter_id,anquan,email) {
		return request.post("/api/user/register", {
			username: username,
			password: password,
			group_id: group_id,
			inviter_id: inviter_id || "",
			anquan:anquan,
			email: email ,
		}, {
			headers: {
				'Content-Type': 'application/json'
			} // 明确请求头
		});
	},
	// 用户登录
	login(account, password) {
		return request.post("/api/user/login", {
			account: account,
			password: password,
		});
	},
};